import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { X } from 'lucide-react';

/**
 * Generic inline drill-through table shown within the Dashboard tab (no navigation, no pop-up).
 * `columns` = [{ key, label }], `rows` = array of plain objects with matching keys.
 */
export const DashboardDrillThroughPanel = ({ title, columns, rows = [], onRowClick, onClose, testId = 'drill-through-panel' }) => (
  <Card className="border-2 border-lime/40" data-testid={testId}>
    <CardHeader className="flex flex-row items-start justify-between gap-3 pb-3">
      <div>
        <CardTitle className="font-heading text-base">{title}</CardTitle>
        <CardDescription className="text-xs">{rows.length} matching record{rows.length !== 1 ? 's' : ''}</CardDescription>
      </div>
      <Button variant="ghost" size="icon" className="h-7 w-7" onClick={onClose} data-testid={`${testId}-close`}>
        <X className="w-4 h-4" />
      </Button>
    </CardHeader>
    <CardContent>
      {rows.length > 0 ? (
        <div className="max-h-80 overflow-y-auto border rounded-lg">
          <Table>
            <TableHeader>
              <TableRow>
                {columns.map(c => <TableHead key={c.key}>{c.label}</TableHead>)}
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((row, i) => (
                <TableRow
                  key={row.id || row._key || i}
                  className={onRowClick ? 'cursor-pointer hover:bg-muted/50' : ''}
                  onClick={() => onRowClick && onRowClick(row)}
                  data-testid={`${testId}-row-${i}`}
                >
                  {columns.map(c => (
                    <TableCell key={c.key} className="text-sm">{row[c.key] ?? '—'}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      ) : (
        <p className="text-center text-muted-foreground py-8 text-sm">No matching records</p>
      )}
    </CardContent>
  </Card>
);

export default DashboardDrillThroughPanel;
